import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAllergies,
  faBacteria,
  faBandAid,
  faBrain,
  faBug,
  faCarrot,
  faCloudsSun,
  faCommentMedical,
  faCrutch,
  faEar,
  faEye,
  faFaucet,
  faHandsHoldingHeart,
  faHeadSideCough,
  faHouseChimneyHeart,
  faLungs,
  faMindShare,
  faPills,
  faRibbon,
  faSkullCrossbones,
  faStethoscope,
  faStomach,
  faTooth,
  faTurkey,
  faUserMd,
  faVial,
  faVialVirus,
  faVirusCovid,
  faViruses,
  faWeight,
  faWhistle,
  faWorm,

  // TODO remove legacy health concern icons
  // eslint-disable-next-line sort-imports
  faCut,
  faHeartbeat,
  faPoop,
  faUser,
} from '@fortawesome/pro-light-svg-icons';

library.add({
  faAllergies,
  faBacteria,
  faBandAid,
  faBrain,
  faBug,
  faCarrot,
  faCloudsSun,
  faCommentMedical,
  faCrutch,
  faEar,
  faEye,
  faFaucet,
  faHandsHoldingHeart,
  faHeadSideCough,
  faHouseChimneyHeart,
  faLungs,
  faMindShare,
  faPills,
  faRibbon,
  faSkullCrossbones,
  faStethoscope,
  faStomach,
  faTooth,
  faTurkey,
  faUserMd,
  faVial,
  faVialVirus,
  faVirusCovid,
  faViruses,
  faWeight,
  faWhistle,
  faWorm,

  // TODO remove legacy health concern icons
  faCut,
  faHeartbeat,
  faPoop,
  faUser,
});

export default {};
